<script lang="ts">
  import { push } from 'svelte-spa-router';
  import Table from '../../Table.svelte';
  import type { RecentPendingRequest } from '../../../lib/api/employer';
  import { formatDate } from '../../../lib/utils/formatters';

  export let requests: RecentPendingRequest[] = [];
  export let loading = false;
  export let error: string | null = null;

  const columns = [
    {
      key: 'employee',
      label: 'Employee',
      width: '35%',
      mobilePrimary: true,
      render: (_: unknown, row: RecentPendingRequest) =>
        `<span class="employee-name">${row?.user?.full_name || ''}</span>`
    },
    {
      key: 'charity',
      label: 'Charity',
      width: '35%',
      render: (_: unknown, row: RecentPendingRequest) =>
        `<span class="charity-name">${row?.charity?.name || 'N/A'}</span>`
    },
    {
      key: 'hours',
      label: 'Hours',
      width: '15%',
      render: (_: unknown, row: RecentPendingRequest) =>
        `<span class="hours-value">${row.leave_hours} hrs</span>`
    },
    {
      key: 'date',
      label: 'Date',
      width: '15%',
      render: (_: unknown, row: RecentPendingRequest) =>
        `<span class="date-value">${formatDate(row.created_at)}</span>`
    }
  ];

  function handleRowClick(row: RecentPendingRequest) {
    if (row?.uuid) {
      push(`/view-leave-request?id=${row.uuid}`);
    }
  }
</script>

{#if loading}
  <div class="loading-container">
    <div class="loading-spinner"></div>
    <p>Loading pending requests...</p>
  </div>
{:else if error}
  <div class="error-container">
    <p class="error-message">{error}</p>
  </div>
{:else}
  <Table
    actionText="View All"
    actionHref="#/leave-requests"
    {columns}
    data={requests}
    onRowClick={handleRowClick}
  />
{/if}

<style>
  .loading-container,
  .error-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 3rem;
    text-align: center;
    background: white;
    border-radius: 12px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  }

  .loading-spinner {
    width: 2rem;
    height: 2rem;
    border: 3px solid #f3f4f6;
    border-top: 3px solid #f0b429;
    border-radius: 50%;
    animation: spin 1s linear infinite;
    margin-bottom: 1rem;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  .error-message {
    color: #dc2626;
    font-size: 1.1rem;
  }

  :global(.employee-name),
  :global(.charity-name) {
    font-weight: 500;
    color: #111827;
  }

  :global(.hours-value) {
    color: #374151;
  }

  :global(.date-value) {
    color: #6b7280;
  }
</style>
